<script>
export default {
  functional: true,
  props: {
    justify: {
      type: String,
      validator: val => ['start', 'end', 'between', 'center', 'around'].includes(val)
    },
    align: {
      type: String,
      validator: val => ['start', 'end', 'center', 'stretch', 'baseline'].includes(val)
    }
  },
  render(h, ctx) {
    const fullClassList = ['row']

    if (ctx.props.justify) {
      fullClassList.push(`row--justify_${ctx.props.justify}`)
    }
    if (ctx.props.align) {
      fullClassList.push(`row--align_${ctx.props.align}`)
    }

    return h(
      'div',
      {
        ...ctx.data,
        class: fullClassList
      },
      ctx.children
    )
  }
}
</script>
